import React, { Component } from 'react';
import DashboardBoxes from 'components/__old/common/dashboard-boxes';
import TabSettings from 'components/__old/common/tabSettings.jsx';
import { connect } from "react-redux";
import { customizeSVG } from 'utils/customizeSVG.jsx';
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ReactComponent as IconUsers } from "assets/images/icons/project-icons/employees.svg";
// import { ReactComponent as Xclose } from "assets/images/icons/project-icons/xclose.svg";
// import bento from "assets/images/logos/bento.svg";

class Integrations extends Component {

    state = {
        dashboardProps1: {
            iconBg: "bg-red-100",
            icon: <IconUsers className="customizeSVG text-red-600 m-auto w-7 h-7" />,
            titleText: "Employees on Earnipay",
            mainText: "-"
        },
        dashboardProps2: {
            iconBg: "bg-blue-100",
            icon: <IconUsers className="customizeSVG text-blue-600 m-auto w-7 h-7" />,
            titleText: "Employees on Bento",
            mainText: "-"
        },
        dashboardProps3: {
            iconBg: "bg-blue-100",
            icon: <IconUsers className="customizeSVG text-blue-600 m-auto w-7 h-7" />,
            titleText: "Total Amount (WIthdrawals) to Bento",
            mainText: "-"
        },
        autosync: {
            status: "on"
        }
    }



    formChangeRadio = (e) => {
        const formValue = {...this.state.autosync, status: e.target.value};
        // console.log(formValue);
        this.setState({autosync: formValue});
    }


    render() { 
        customizeSVG();

        return ( 
            <div>

                
                <div className="lg:flex">
                    <div className="w-full lg:w-1/2">
                        <div className="page-title">
                            Settings
                        </div>
                    </div>
                </div>

                <TabSettings />

                <div className="mt-8">
                    <Link to="/settings/integrations/bento" className="btn btn-md btn-ep-primary">
                        <FontAwesomeIcon icon="angle-left" className="text-lg" />
                        <span>
                            BENTO
                        </span>
                    </Link>
                </div>

                <div className="mt-8">

                    <div className="xl:flex xl:space-x-6 space-y-6 xl:space-y-0">

                        <div className="xl:w-1/2 box">
                            <div className="font-bold text-gray-600">
                                Manage Data
                            </div>
                            <div className="my-4">

                                <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-2 gap-6">
                                    <DashboardBoxes data={this.state.dashboardProps1} result="65" />
                                    <DashboardBoxes data={this.state.dashboardProps2} result="69" />
                                </div>

                                <hr className="mt-10" />

                                <div className="flex py-10 justify-between space-x-4 items-center">
                                    <div className="font-medium text-gray-400">
                                        Sync Employees from Bento
                                    </div>
                                    <button className="btn btn-ep-secondary whitespace-nowrap">
                                        Sync Employees Now
                                    </button>
                                </div>

                            </div>
                        </div>

                        <div className="xl:w-1/2 box">

                            <div className="font-bold text-gray-600">
                                Withdrawals Data
                            </div>
                            <div className="my-4">

                                <div className="mt-6 flex justify-between space-x-4 items-center">
                                    <div className="font-medium text-gray-400">
                                        Automatic Sync 
                                        <br />
                                        ( Employees and Withdrawals)
                                    </div>
                                    <div>
                                        <label className="input-toggle">
                                            <input type="checkbox" 
                                                checked={ this.state.autosync.status === "on" } 
                                                onChange={this.formChangeRadio}
                                                value="on"
                                             />
                                            <span className="slider round"></span>
                                        </label>
                                    </div>
                                </div>

                                <div className="text-ep-secondary mt-6 text-sm font-medium">
                                    * Withdrawals are automatically synced to BENTO on the 25th of Every Month
                                </div>

                                <hr className="my-5" />

                                <div className="grid sm:grid-cols-1 lg:grid-cols-2 xl:grid-cols-1 gap-6">
                                    <DashboardBoxes data={this.state.dashboardProps3} result="₦100,953.55" />
                                </div>

                                <div className="mt-6 flex justify-between space-x-4 items-center">
                                    <div className="font-medium text-gray-400">
                                        Last Sync update
                                    </div>
                                    <div className="text-right">
                                        <div className="font-bold text-ep-primary">
                                            Nov. 26, 2021
                                        </div>
                                        <div className="text-sm text-gray-600">
                                            at 8:57pm
                                        </div>
                                    </div>
                                </div>

                                <hr className="my-5" />

                                <div className="hidden flex py-5 justify-between space-x-4 items-center">
                                    <div className="font-medium text-gray-400">
                                        Sync earnipay withdrawals to Bento
                                    </div>
                                    <button className="btn btn-ep-secondary whitespace-nowrap">
                                        Sync Withdrawals
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        );
    }
}



const mapStateToProps = (state) => ({
    
});

const mapDispatchToProps = (dispatch) => ({
    
});

export default connect(mapStateToProps, mapDispatchToProps)(Integrations);